<template>
  <div class="client-bids">
    <div class="container-fluid client">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1>Complete Your Details</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <div class="table-responsive p-0">
                <div class="settings-card">
                  <div class="settings-row">
                    <label class="settings-label required"
                      >First Name</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      placeholder="First Name"
                      style="width: 450px"
                      v-model="firstName"
                    />
                  </div>
                </div>
                <div class="settings-card">
                  <div class="settings-row">
                    <label class="settings-label required"
                      >Last Name</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Last Name"
                      style="width: 450px"
                      v-model="lastName"
                    />
                    </div>
                </div>
                <div class="settings-card">
                    <div class="settings-row">
                        <label class="settings-label required"
                        >Phone Number</label
                        >
                          <vue-phone-number-input 
                    name="phone" 
                     style="width: 450px"
                    v-model="phoneNumber"
                    :no-country-selector="true"
                     default-country="US"
                    @update="phoneNumberChanged" />
                       
                    </div>
                </div>
                   <br />
                <div v-if="error" class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{error}}
                </div>
                <div class="alert alert-success" role="alert" v-if="dataChanged">
                  <i class="fas fa-check-circle"></i>
                    updated successfully.
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary my-2" @click="updateUser">
                    Update
                    <i
                      v-if="!loading"
                      class="fa fa-arrow-circle-right"
                      aria-hidden="true"
                    ></i>
                    <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";

export default {
  name: "viewdata",
  components: {
    // Header,
    // Footer
  },
  data() {
    return {
      config: config,
      error: null,
      loading: false,
      firstName : "",
      lastName : "",
      phoneNumber : "",
      dataChanged : false,
      formattedNumber : null

    };
  },
  created() {},
  methods: {
     phoneNumberChanged(obj){
      console.log("updated",obj)
      this.formattedNumber  = obj.isValid ? obj.formattedNumber : null
    },
     getUser(){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
            this.firstName = result.data.firstName;
            this.lastName = result.data.lastName;
            this.phoneNumber = result.data.phone;
        })
    },
     updateUser(){
      this.error = false;
      if (!this.firstName) {
        this.error = "First name is required";
        return false;
      }
      if (!this.lastName) {
        this.error = "Last name is required";
        return false;
      }
      if (!this.phoneNumber) {
        this.error = "Phone Number is required";
        return false;
      }
       if (this.formattedNumber == null) {
        this.error = "Invalid phone number";
        return false;
      }
     
      let dataToSend = {...authService.getUser()};
      dataToSend.firstName = this.firstName;
      dataToSend.lastName = this.lastName;
      dataToSend.phone = this.formattedNumber;
      dataToSend.status = "ACTIVE";
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/user",
          dataToSend,
          auth
        )
        .then(() => {
            this.dataChanged = true;
            this.$router.push("/client/dashboard");
         
        })
        .catch(e => {
          console.log(e);
        });
    },

  },
  mounted() {
    this.getUser();
  }
};
</script>

<style scoped>
.settings-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.settings-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.settings-label {
  width: 250px; /* Fixed label width */
  font-size: 14px;
  font-weight: 500;
  color: #bbbbbb;
}

.settings-input {
  width: 350px; /* FIX INPUT WIDTH */
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.button-wrap {
  display: flex;
  justify-content: flex-end; /* Button moves to right */
  margin-top: 10px;
}
.settings-label.required::after {
  content: " *";
  color: red;
}
</style>
